import i from 'i18next'

import { FormGroup, Input, Label } from '~/components/unform'

const labelKey = 'rm:campaign.create.SponsoredBrand.elements.brandName'

const BrandPage = () => (
  <FormGroup>
    <Label isRequired text={i.t(labelKey)} />
    <Input required name="brand_name" placeholder={i.t(labelKey)} />
  </FormGroup>
)

export default BrandPage
